"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var ApiStatus_1 = __importDefault(require("~/util/ApiStatus"));
var URL_API_ENDPOINTS = {
    GET_STORES: '/api/stores/gps_search',
};
var GoogleMapStore = /** @class */ (function () {
    function GoogleMapStore() {
        this.map = null;
        this.activeMarker = null;
        this.activeStore = null;
        this._stores = [];
        this._getStoresStatus = ApiStatus_1.default.INITIAL;
    }
    Object.defineProperty(GoogleMapStore.prototype, "stores", {
        get: function () {
            return this._stores;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoogleMapStore.prototype, "getStoresStatus", {
        get: function () {
            return this._getStoresStatus;
        },
        enumerable: false,
        configurable: true
    });
    GoogleMapStore.prototype.fetchStores = function (bounds) {
        var _this = this;
        if (this._getStoresStatus.isLoading) {
            return;
        }
        var params = {
            lat_lo: bounds.getSouthWest().lat(),
            lat_hi: bounds.getNorthEast().lat(),
            lon_lo: bounds.getSouthWest().lng(),
            lon_hi: bounds.getNorthEast().lng()
        };
        this._getStoresStatus = ApiStatus_1.default.LOADING;
        axios_1.default
            .get(URL_API_ENDPOINTS.GET_STORES, { params: params })
            .then(function (res) {
            var data = res.data.data;
            _this._stores = (data === null || data === void 0 ? void 0 : data.stores) || [];
            _this._getStoresStatus = ApiStatus_1.default.SUCCESS;
        })
            .catch(function () {
            _this._getStoresStatus = ApiStatus_1.default.FAILED;
        });
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], GoogleMapStore.prototype, "map", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], GoogleMapStore.prototype, "activeMarker", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], GoogleMapStore.prototype, "activeStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], GoogleMapStore.prototype, "_stores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_e = typeof ApiStatus_1.default !== "undefined" && ApiStatus_1.default) === "function" ? _e : Object)
    ], GoogleMapStore.prototype, "_getStoresStatus", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], GoogleMapStore.prototype, "fetchStores", null);
    return GoogleMapStore;
}());
exports.default = GoogleMapStore;
